import { render } from "./ChartElementOperate.vue?vue&type=template&id=4218643e&ts=true"
import script from "./ChartElementOperate.vue?vue&type=script&lang=ts"
export * from "./ChartElementOperate.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__